import axios from 'axios';
import { API_URL } from '../Auth/constansts';

const PermissionListAPI = async (token, companyid) => {
  try {
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${API_URL}/rpp/getpermissios`,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      data: {
        companyid: companyid
      }
    };
    const data = await axios.request(config);
    if (data.status === 200) {
      return data.data;
    }
    else {
      return 201;
    }
  } catch (error) {
    return 500;
  }
}

const RoleListAPI = async (token, companyid) => {
  try {
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${API_URL}/rpp/getroles`,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      data: {
        companyid: companyid
      }
    };
    const data = await axios.request(config);
    if (data.status === 200) {
      return data.data;
    }
    else {
      return 201;
    }
  } catch (error) {
    return 500;
  }
}


const RoleShowAPI = async (token, companyid, roleid) => {
  try {
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${API_URL}/rpp/getrole`,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      data: {
        companyid: companyid,
        roleid: roleid
      }
    };
    const data = await axios.request(config);
    if (data.status === 200) {
      return data.data;
    }
    else {
      return 201;
    }
  } catch (error) {
    return 500;
  }
}

const RoleCreateAPI = async (token, companyid, name, description, permissions) => {
  try {
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${API_URL}/rpp/setroles`,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      data: {
        companyid: companyid,
        name: name,
        description: description,
        permissions: permissions
      }
    };
    const data = await axios.request(config);
    if (data.status === 200) {
      return data.data;
    }
    else {
      return 201;
    }
  } catch (error) {
    return 500;
  }
}


const PlanCreateAPI = async (token, companyid, name, duration, price, privateV, permissions) => {
  try {
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${API_URL}/rpp/setplan`,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      data: {
        companyid: companyid,
        name: name,
        duration: duration,
        price: price,
        private: privateV,
        permissions: permissions
      }
    };
    const data = await axios.request(config);
    if (data.status === 200) {
      return data.data;
    }
    else {
      return 201;
    }
  } catch (error) {
    return 500;
  }
}

const PlanShowAPI = async (token, companyid, planid) => {
  try {
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${API_URL}/rpp/getplan`,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      data: {
        companyid: companyid,
        planid: planid,
      }
    };
    const data = await axios.request(config);
    if (data.status === 200) {
      return data.data;
    }
    else {
      return 201;
    }
  } catch (error) {
    return 500;
  }
}

const PlanListAPI = async (token, companyid) => {
  try {
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${API_URL}/rpp/getplans`,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      data: {
        companyid: companyid
      }
    };
    const data = await axios.request(config);
    if (data.status === 200) {
      return data.data;
    }
    else {
      return 201;
    }
  } catch (error) {
    return 500;
  }
}

export {
  PermissionListAPI,
  RoleCreateAPI,
  RoleListAPI,
  RoleShowAPI,
  PlanCreateAPI,
  PlanShowAPI,
  PlanListAPI
}